module.exports = __webpack_public_path__ + "statics/img/cate10-3@2x.f024b222.png";